import { render } from "./taskInfo.vue?vue&type=template&id=2a34e4a8&scoped=true"
import script from "./taskInfo.vue?vue&type=script&lang=ts"
export * from "./taskInfo.vue?vue&type=script&lang=ts"

import "./taskInfo.vue?vue&type=style&index=0&id=2a34e4a8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a34e4a8"

export default script